module.exports = __webpack_public_path__ + "85fbe5f4d3d48380087d78548d70a6f8.pdf";